module.exports = __webpack_public_path__ + "static/img/14010001.480afd84.png";